
export default {
  // Existing Inscription keys
  form_title: "Formulaire d'inscription et de consentement pour recevoir nos nouveautés",
  basf_intro: "Bienvenue et merci de votre intérêt pour BASF Solutions Agricoles.",
  i_have_read: "J'ai lu et j'accepte",
  data_protection_policy: "la politique de protection des données personnelles",
  i_understand: "de BASF SPA. Je comprends que je peux demander l’actualisation, la rectification, l’effacement ou le verrouillage de mes données personnelles à tout moment conformément à la loi n°18-07 relative à la protection des données personnelles.",
  form_description: "Bienvenue et merci de votre intérêt pour BASF Solutions Agricoles. Pour recevoir nos actualités, conseils agronomiques, alertes maladies, informations produits et invitations à nos événements, veuillez remplir le formulaire ci-dessous.",

  placeholders: {
    last_name: "Nom*",
    first_name: "Prénom*",
    phone: "Numéro de téléphone portable*",
    function: "Sélectionnez votre fonction*",
    company: "Nom de la société ou du point de vente",
    hectares: "Nombre d'hectares",
    wilaya: "Sélectionnez votre Wilaya*",
    search: "Rechercher...",
    commune: "Sélectionnez votre Commune*",
    noResultsFound: " Aucun résultat trouvé"
  },

  labels: {
    cultures: "Sélectionnez la ou les cultures qui vous intéressent :*",
    hectares_note: "(Si vous êtes agriculteur)"
  },

  function: {
    agriculteur: "Agriculteur",
    revendeur: "Revendeur",
    distributeur: "Distributeur",
    inspecteur: "Inspecteur Phytosanitaire",
    consultant: "Consultant agricole ",
    autre: "Autre"
  },

  submit: "Confirmer",

  errors: {
    last_name: "• Nom est obligatoire",
    first_name: "• Prénom est obligatoire",
    phone: "• Numéro de téléphone invalide",
    phone_invalid: "• Numéro de téléphone invalide",
    phone_exists: "• Ce numéro de téléphone est déjà enregistré",
    wilaya: "• Wilaya est obligatoire",
    company: "• Le nom de la société est obligatoire",
    commune: "• Commune est obligatoire",
    cultures: "• Veuillez sélectionner au moins une culture",
    function: "• Fonction est obligatoire",
    rules: "• Pour continuer, veuillez accepter la politique de protection des données personnelles."
  },

  alerts: {
    otp_error: "Impossible d’envoyer le code OTP. Veuillez réessayer.",
    generic_error: "Une erreur est survenue"
  },

  cultures: {
    pomme_de_terre: "Pomme de terre",
    cereales: "Céréales",
    tomate_industrielle: "Tomate industrielle",
    tomate_plein_champ: "Tomate plein champ",
    tomate_sous_serre: "Tomate sous-serre",
    arbres_fruitiers: "Arbre fruitiers",
    melon_pasteque: "Melon/Pastèque",
    autres_cucurbitacees: "Autres cucurbitacées",
    mais: "Maïs (fourrage, grains)",
    oleagineuses: "Oléagineuses",
    agrumes: "Agrumes",
    vigne: "Vigne",
    legumineuses: "Légumineuses (Lentille, pois chiche, féverole)"
  },

  phoneConfirmation: {
    successTitle: "Inscription Réussie",
    successMessage: "Merci ! Votre inscription est confirmée.",
    go_to_profile: "Consulter mon profil",
    okButton: "OK",
    confirmTitle: "Confirmer l'inscription",
    confirmDescription: "Pour finaliser votre inscription, veuillez saisir le code à 5 chiffres que vous avez reçu par SMS.",
    errorMessage: "Le code saisi est incorrect. Veuillez réessayer.",
    resentMessage: "Le code a été renvoyé.",
    resendCode: "Renvoyer le code",
    resendIn: "Renvoyer dans {seconds}s",
    confirmButton: "Confirmer"
  },

  login: {
    title: "Connexion",
    subtitle: "Connectez-vous avec votre numéro de téléphone",
    phoneLabel: "Numéro de téléphone",
    sendCode: "Envoyer le code",
    noAccount: "Si vous n'avez pas encore de compte,",
    signUp: "inscrivez-vous",
    otpSent: "Un code a été envoyé à votre numéro.",
    codeError: "Code incorrect.",
    resendCode: "Renvoyer le code",
    resendIn: "Renvoyer dans {seconds}s",
    confirm: "Confirmer",
    sendingCode: "Envoi du code au numéro :",
    cancel: "Annuler",
    phoneRequired: "Le numéro de téléphone est requis.",
    phoneInvalid: "Le numéro doit commencer par 0 et contenir 10 chiffres.",
    phoneInvalidGeneric: "Ce numéro de téléphone n’est pas enregistré.",
  },

  edit: {
    intro: "Vos informations actuelles s'affichent sur le formulaire ci-dessous. Vous pouvez les modifier puis cliquer sur le bouton Confirmer.",
    last_name: "Nom*",
    first_name: "Prénom*",
    phone: "Numéro de téléphone portable*",
    function: "Sélectionnez votre fonction*",
    company: "Nom de la société ou du domaine",
    hectares: "Nombre d'hectars",
    if_farmer: "(Si vous êtes agriculteur)",
    cultures_label: "Sélectionnez la ou les cultures qui vous intéressent :*",
    select_wilaya: "Sélectionnez votre Wilaya*",
    select_commune: "Sélectionnez votre Commune*",
    confirm: "Confirmer",
    done_editing: "Vous avez terminé de modifier vos informations ?",
    logout: "Se déconnecter",
    errors: {
      last_name: "• Nom est obligatoire",
      first_name: "• Prénom est obligatoire",
      phone: "• Numéro de téléphone invalide",
      function: "• Fonction est obligatoire",
      wilaya: "• Wilaya est obligatoire",
      commune: "• Commune est obligatoire",
      cultures: "• Veuillez sélectionner au moins une culture"
    }
  },

  edit_otp: {
    title: "Confirmer la Modification",
    description: "Pour finaliser votre modification, veuillez saisir le code à 5 chiffres que vous avez reçu par SMS.",
    error: "Le code saisi est incorrect. Veuillez réessayer.",
    resent: "Le code a été renvoyé.",
    resend: "Renvoyer le code",
    resend_in: "Renvoyer dans {seconds}s",
    confirm: "Confirmer",
    cancel: "Annuler"
  },

  admin_dashboard: {
    stats: {
      total_submissions: "Total des Soumissions",
      top_culture: "Top Culture",
      avg_hectares: "Moyenne des Hectars",
      top_function: "Top Fonction"
    },
    export: "Télécharger Fichier Excel",
    table: {
      last_name: "Nom",
      first_name: "Prénom",
      phone: "Téléphone",
      function: "Fonction",
      company: "Société",
      hectares: "Hectars",
      wilaya: "Wilaya",
      commune: "Commune",
      cultures: "Cultures",
      date: "Date d'Inscription"
    },
    pagination: {
      previous: "Page Précédente",
      next: "Page Suivante"
    },
    title: "Tableau de bord"
  },

  admin: {
    title: "Connexion",
    subtitle: "Connectez-vous avec votre email & mot de passe",
    email: "Email",
    password: "Mot de Passe",
    submit: "Se Connecter",
    errors: {
      email_required: "Le e-mail est requis.",
      password_required: "Le mot de passe est requis.",
      password_invalid: "Le mot de passe est invalide.",
      invalid_credentials: "Identifiants invalides."
    },
    logout: "Se déconnecter",
    forgot_password: "Mot de passe oublié ?",
    recover_password: " Cliquez ici pour le récupérer"
  },

  recover_password: {
    title: "Mot de passe oublié",
    subtitle: "Récupérez votre compte en utilisant votre numéro de téléphone",
    phoneLabel: "Numéro de téléphone",
    sendCode: "Envoyer le code de réinitialisation",
    noAccount: "Vous n'avez pas encore de compte ?",
    signUp: "Inscrivez-vous",
    otpSent: "Un code de réinitialisation a été envoyé à votre numéro.",
    codeError: "Code de vérification incorrect.",
    resendCode: "Renvoyer le code",
    resendIn: "Renvoyer dans {seconds}s",
    confirm: "Confirmer le code",
    sendingCode: "Envoi du code de réinitialisation au numéro :",
    cancel: "Annuler",
    phoneRequired: "Le numéro de téléphone est requis pour réinitialiser votre mot de passe.",
    phoneInvalid: "Le numéro doit commencer par 0 et contenir 10 chiffres.",
    phoneInvalidGeneric: "Numéro de téléphone invalide.",
    resetPassword: "Saisissez votre nouveau mot de passe",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    submitNewPasword: "Confirmer",
    successMessage: "Votre Mot de passe a été modifié avec succès.",
    successTitle: "Réinitialisation du mot de passe réussie",
  },

  admin_edit: {

    title: "Modifier les informations de compte administrateur",
    change_email: "Changer l'email",
    email: "Email",
    change_phone: "Changer le numéro de téléphone",
    phone: "Numéro de téléphone",
    change_password: "Changer le mot de passe",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    submit: "Confirmer",
    validate: "Valider",
    cancel: "Annuler",
    menu_item: "Modifier vos informations",
    modal_password_title: "Confirmez vos changements",
    modal_password_sub: "Veuillez saisir votre mot de passe actuel pour valider les modifications apportées à votre compte.",
    successMessage: "Vos données ont été modifiées avec succès.",

    errors: {
      phoneInvalid: "• Numéro de téléphone invalide",
      alreadyExistPhone: "• Ce numéro de téléphone existe déjà",
      invalidPassword: "• Mot de passe invalide",
      emailRequired: "• Adresse email Invalide",
      alreadyExistEmail: "• Adresse email déjà utilisée",
      weakPassword: "• Le nouveau mot de passe doit contenir au moins 8 caractères",
      passwordMismatch: "• Les mots de passe ne correspondent pas"
    }
  },

  admin_create: {
    admin_list: "Liste d'Admins",
    title: "Création d'un compte Admin",
    subtitle: "Remplir les informations nessescaire pour creé un nouveau admin",
    email: "Email",
    phone: "Numéro de téléphone",
    password: "Mot de passe",
    confirm_password: "Confirmer le mot de passe",
    submit: "Sauvegarder",
    cancel: "Annuler",
    errors: {
      email_required: "Email requis",
      email_invalid: "Email invalide",
      email_exists: "Email existe",
      password_required: "Mot de passe requis",
      password_short: "Mot de passe court",
      phone_required: "Téléphone requis",
      phone_invalid: "Numero Téléphone invalide",
      phone_exists: "Ce numéro de téléphone est déjà enregistré",
      password_mismatch: "• Les mots de passe ne correspondent pas"

    }
  },


  deleteInfo: "Supprimer mes données personnelles",
  successTitle: "Modification de vos données personnelles",
  successMessage: "Vos données personnelles ont été modifiées avec succès.",
  deleteErrorTitle: "Suppression de vos données personnelles",
  deleteErrorMessage: "Erreur : vos données personnelles n'ont pas pu être supprimées.",
  deleteSuccessTitle: "Suppression de vos données personnelles",
  deleteSuccessMessage: "Vos données personnelles ont bien été supprimées.",
  deleteConfirmTitle: "Suppression de vos données personnelles",
  deleteConfirmMessage: "Confirmez-vous que vous souhaitez supprimer vos données personnelles et ne plus recevoir aucune communication de la part de BASF SPA ?",
  deleteConfirmCancel: "Annuler",
  deleteConfirmDelete: "Supprimer",
  already_have_account: "Veuillez remplir tous les champs obligatoires *",
  loginMsg: "Modifier ou Supprimer mes données."
}
